module.exports = __webpack_public_path__ + "static/media/favicon-lighthouse710.88ebd0c9.ico";